// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__2rQng","logo":"MainNavigation_logo__1OLM4","nav":"MainNavigation_nav__36uMc","active":"MainNavigation_active__3eZTW"};